import styled from "@emotion/styled";

export const Container = styled("div")(() => ({
  position: "relative" as const,
  minHeight: "100%",
}));
